export const LEGAL_TEXT_VERSION = '2026-04-02';
export const LEGAL_LAST_UPDATED_LABEL = '2 aprile 2026';

export const BUSINESS_INFO = {
  legalName: 'Panetteria Primavera',
  brandName: 'Panetteria Primavera',
  address: 'Via Portofino, 20, 73057 Taviano (LE), Italia',
  phone: '+39 0833 1624313',
  email: 'frasavino13@gmail.com',
  vatNumber: 'DA CONFERMARE CON COMMERCIALISTA',
  reaNumber: 'DA CONFERMARE CON COMMERCIALISTA',
  cciaaOffice: 'DA CONFERMARE CON COMMERCIALISTA',
  pec: 'DA CONFERMARE CON COMMERCIALISTA',
  dataControllerEmail: 'frasavino13@gmail.com'
};

const PLACEHOLDER_MARKER = 'DA CONFERMARE';

function isPlaceholder(value) {
  return String(value || '')
    .toUpperCase()
    .includes(PLACEHOLDER_MARKER);
}

export function hasIncompleteLegalBusinessInfo() {
  return Object.values(BUSINESS_INFO).some(isPlaceholder);
}
